enum SubscriptionTypes {
  PERCEPTION_PLAYLIST = "PERCEPTION_PLAYLIST",
  TRAINING_PLAYLIST = "TRAINING_PLAYLIST",
  TUTORIAL_PLAYLIST = "TUTORIAL_PLAYLIST",
  AWARENESS_PLAYLIST = "AWARENESS_PLAYLIST",
  MINIGAME_PLAYLIST = "MINIGAME_PLAYLIST",
  PRIVATE_PLAYLIST = "PRIVATE_PLAYLIST",
  FEATURE_SWITCH = "FEATURE_SWITCH",
  PLATFORM_ACCESS = "PLATFORM_ACCESS",
  STYLE_ENV = "STYLE_ENV",
  STYLE_TEAM = "STYLE_TEAM",
};

export default SubscriptionTypes;